import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { DateTime } from 'luxon';
import { Router } from '@angular/router';

export enum HolidayListType {
  HolidayPerMonthList = 'HolidayPerMonthList'
}

@Component({
  selector: 'app-holiday-list',
  templateUrl: './holiday-list.component.html',
  styleUrl: './holiday-list.component.scss',
  standalone: false
})
export class HolidayListComponent implements OnInit {
  private router = inject(Router);

  @ViewChild(MatTabGroup, { static: true }) tabGroup: MatTabGroup;

  navigation = [
    {
      listType: HolidayListType.HolidayPerMonthList,
      link: `holidays/${DateTime.now().toFormat('yyyy/MM')}`,
      linkTemplate: new RegExp('(\\d{4}\\/\\d{2})$'),
    }
  ];

  constructor() { }

  ngOnInit(): void {
    this.tabGroup.selectedIndex = this.navigation.findIndex(n => n.linkTemplate.test(this.router.url));
  }

  onTabChanged(event: MatTabChangeEvent): void {
    this.router.navigateByUrl(this.navigation[event.index].link);
  }
}
